export default {
      id: "sli-plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-plus",
      toString: function () {
        return this.url;
      }
    }